// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"5967d6f8","216":"083a649f","355":"26f4dc68","706":"4105c46b","976":"68434b3c"}[chunkId] + ".chunk.js";
};